module.exports = __webpack_public_path__ + "files/1f95200522e350907fd259f81ebc4b49.png";